import {
  Box,
  Stack,
  useDisclosure,
  useColorModeValue,
  Image,
  Modal,
  ModalBody,
  ModalOverlay,
  ModalContent,
  Breadcrumb,
  BreadcrumbItem,
  BreadcrumbLink,
  Container,
} from '@chakra-ui/react';
import 'assets/css/plugin-styles.css';
import Configurator from 'components/Configurator/Configurator';
import Footer from 'components/Footer/Footer.js';
// Custom components
import MainPanel from 'components/Layout/MainPanel';
import PanelContainer from 'components/Layout/PanelContainer';
import PanelContent from 'components/Layout/PanelContent';
// Layout components
import AdminNavbar from 'components/Navbars/AdminNavbar.js';
import Sidebar from 'components/Sidebar/Sidebar.js';
import { SidebarContext } from 'contexts/SidebarContext';
import React, { useState, useEffect } from 'react';
import 'react-quill/dist/quill.snow.css'; // ES6
import { Redirect, Route, Switch } from 'react-router-dom';
import routesArray from 'routes.js';
import { getLogo } from 'helpers/logo';
import { useLocation } from 'react-router-dom';
import SearchInput from 'components/SeachInput/SearchInput';

export default function Dashboard(props) {
  const routes = routesArray();
  const {
    isOpen: isOpenSearch,
    onOpen: onOpenSearch,
    onClose: onCloseSearch,
  } = useDisclosure();
  useEffect(() => {
    function handleKeyDown(event) {
      if (event.keyCode === 113) {
        onOpenSearch();
      }
    }
    document.addEventListener('keydown', handleKeyDown);
    return () => {
      document.removeEventListener('keydown', handleKeyDown);
    };
  }, []);
  const { ...rest } = props;
  // states and functions
  const [fixed, setFixed] = useState(false);
  const [toggleSidebar, setToggleSidebar] = useState(false);
  const [sidebarWidth, setSidebarWidth] = useState(275);
  // ref for main panel div
  const mainPanel = React.createRef();
  // functions for changing the states from components
  const getRoute = () => {
    return window.location.pathname !== '/admin/full-screen-maps';
  };
  const getActiveRoute = (routes) => {
    let activeRoute = 'Default Brand Text';
    for (let i = 0; i < routes.length; i++) {
      if (routes[i].collapse) {
        let collapseActiveRoute = getActiveRoute(routes[i].items);
        if (collapseActiveRoute !== activeRoute) {
          return collapseActiveRoute;
        }
      } else if (routes[i].category) {
        let categoryActiveRoute = getActiveRoute(routes[i].items);
        if (categoryActiveRoute !== activeRoute) {
          return categoryActiveRoute;
        }
      } else {
        if (routes[i].detail) {
          const parts = window.location.hash.substring(1).split('/');
          if (!isNaN(parts[parts.length - 1])) {
            parts.pop();
          }
          if (parts.pop() === routes[i].detail) {
            return routes[i].name;
          }
        } else {
          if (
            window.location.href.indexOf(routes[i].layout + routes[i].path) !==
            -1
          ) {
            return routes[i].name;
          }
        }
      }
    }
    return activeRoute;
  };
  const getActiveRoutePath = (routes) => {
    let activeRoute = 'Default Brand Text';
    for (let i = 0; i < routes.length; i++) {
      if (routes[i].collapse) {
        let collapseActiveRoute = getActiveRoutePath(routes[i].items);
        if (collapseActiveRoute !== activeRoute) {
          return collapseActiveRoute;
        }
      } else if (routes[i].category) {
        let categoryActiveRoute = getActiveRoutePath(routes[i].items);
        if (categoryActiveRoute !== activeRoute) {
          return categoryActiveRoute;
        }
      } else {
        if (
          window.location.href.indexOf(routes[i].layout + routes[i].path) !== -1
        ) {
          return routes[i].path;
        }
      }
    }
    return activeRoute;
  };
  const getActiveNavbar = (routes) => {
    let activeNavbar = false;
    for (let i = 0; i < routes.length; i++) {
      if (routes[i].collapse) {
        let collapseActiveNavbar = getActiveNavbar(routes[i].items);
        if (collapseActiveNavbar !== activeNavbar) {
          return collapseActiveNavbar;
        }
      } else if (routes[i].category) {
        let categoryActiveNavbar = getActiveNavbar(routes[i].items);
        if (categoryActiveNavbar !== activeNavbar) {
          return categoryActiveNavbar;
        }
      } else {
        if (
          window.location.href.indexOf(routes[i].layout + routes[i].path) !== -1
        ) {
          return routes[i].secondaryNavbar;
        }
      }
    }
    return activeNavbar;
  };
  const getRoutes = (routes) => {
    return routes.map((prop, key) => {
      if (prop.layout === '/admin') {
        return (
          <Route
            path={prop.layout + prop.path}
            component={prop.component}
            key={key}
            exact
          />
        );
      }
      if (prop.collapse) {
        return getRoutes(prop.items);
      }
      if (prop.category) {
        return getRoutes(prop.items);
      } else {
        return null;
      }
    });
  };
  let bgBoxHeight = '100vh';
  let bgBoxColor = useColorModeValue('white', 'navy.900');

  const { isOpen, onOpen, onClose } = useDisclosure();
  document.documentElement.dir = 'ltr';
  document.documentElement.layout = 'admin';

  const location = useLocation();
  const parts = location.pathname.split('/');
  return (
    <>
      <SidebarContext.Provider
        value={{
          sidebarWidth,
          setSidebarWidth,
          toggleSidebar,
          setToggleSidebar,
        }}
      >
        {/* <Box
          minH={bgBoxHeight}
          h="100% !important"
          w="100%"
          position="absolute"
          bg={bgBoxColor}
          top="0"
        /> */}
        <AdminNavbar
          onOpen={onOpen}
          logoText={'Argon Dashboard Chakra PRO'}
          brandText={getActiveRoute(routes)}
          secondary={getActiveNavbar(routes)}
          path={getActiveRoutePath(routes)}
          fixed={fixed}
          {...rest}
          onOpenSearch={onOpenSearch}
        />
        <Sidebar
          routes={routes}
          logo={
            <Stack
              direction='row'
              spacing='12px'
              align='center'
              justify='center'
            >
              <Image src={getLogo()} alt='logo' width={100} height={70} objectFit='contain' />
            </Stack>
          }
          display='none'
          {...rest}
        />
        <Box bg='white'>
          <Container maxW='100%' py='8px' px={{ sm: '16px', md: '24px' }}>
            <Breadcrumb fontSize={{ base: 'sm' }}>
              <BreadcrumbItem color={'gray.900'}>
                <BreadcrumbLink
                  href={`#/admin${getActiveRoutePath(routes)}`}
                  color={'gray.900'}
                >
                  {parts.slice(2, 3)[0].charAt(0).toUpperCase() +
                    parts.slice(2, 3)[0].slice(1)}
                </BreadcrumbLink>
              </BreadcrumbItem>

              <BreadcrumbItem color={'gray.900'}>
                <BreadcrumbLink color={'gray.900'}>
                  {getActiveRoute(routes)}
                </BreadcrumbLink>
              </BreadcrumbItem>
            </Breadcrumb>
          </Container>
        </Box>
        <MainPanel
          w={{
            base: '100%',
            // xl: `calc(100% - ${sidebarWidth === 275 ? "250" : "0"}px)`,
          }}
        >
          {getRoute() ? (
            <PanelContent>
              <PanelContainer>
                <Switch>
                  {getRoutes(routes)}
                  <Redirect from='/admin' to='/admin/setting/profile' />
                </Switch>
              </PanelContainer>
            </PanelContent>
          ) : null}
          <Box>
            <Footer />
          </Box>
          <Configurator
            secondary={getActiveNavbar(routes)}
            isOpen={isOpen}
            onClose={onClose}
            isChecked={fixed}
            onSwitch={(value) => {
              setFixed(value);
            }}
          />
        </MainPanel>
      </SidebarContext.Provider>
      <Modal isOpen={isOpenSearch} onClose={onCloseSearch} size={{ base: 'full', md: 'xl' }}>
        <ModalOverlay />
        <ModalContent mx={{ base: 2, md: 'auto' }} my={{ base: 2, md: '3.75rem' }} maxH={{ base: 'calc(100vh - 16px)', md: 'auto' }}>
          <ModalBody p={{ base: 3, md: 6 }}>
            <SearchInput isModal={true} onClose={onCloseSearch} />
          </ModalBody>
        </ModalContent>
      </Modal>
    </>
  );
}
